import { HTTP_ERRORS } from '@/constants'

const parseHTTPError = (error) => {
  const httpErrorMessage = HTTP_ERRORS[error?.response?.status]
  return httpErrorMessage || error?.response?.data?.message || error.message
}

export { parseHTTPError }
